import { createContext, useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

export const FustContext = createContext();

export const FustProvider = ({ children }) => {
  const { pathname } = useLocation();
  const [fustCompanies, setFustCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const inFlightRef = useRef(null);

  const isTransportPage = /^\/transport(\/|$)/.test(pathname || "");
  const transportMode = localStorage.getItem("transportMode") === "1";
  const transportUser = JSON.parse(localStorage.getItem("transportUser") || "null");
  const shippingAgent = transportUser?.company || null;

  useEffect(() => {
    if (!isTransportPage || !transportMode || !shippingAgent) return;

    const fetchKey = `fust:${shippingAgent}:${pathname}`;
    if (inFlightRef.current === fetchKey) return;
    inFlightRef.current = fetchKey;

    const controller = new AbortController();

    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/fust`,
          {
            headers: { "X-Shipping-Agent": shippingAgent },
            signal: controller.signal,
          }
        );
        setFustCompanies(Array.isArray(res.data) ? res.data : (res.data || []));
      } catch (err) {
        if (!axios.isCancel(err)) {
          console.error("❌ Fust ophalen mislukt:", err);
          setError("Kon fustgegevens niet ophalen.");
        }
      } finally {
        if (inFlightRef.current === fetchKey) inFlightRef.current = null;
        setLoading(false);
      }
    };

    run();
    return () => controller.abort();
  }, [isTransportPage, transportMode, shippingAgent, pathname]);

  return (
    <FustContext.Provider value={{ fustCompanies, loading, error }}>
      {children}
    </FustContext.Provider>
  );
};
